function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M146.298 21.39c37.204 18.503-2.401 56.32-65.968 104.902C30.47 167.39-2.445 78.589 12.51 48.082 27.466 17.577 109.094 2.886 146.298 21.39z"
});

function SvgTextBlob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 144,
    fill: "#BE81CB"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc2IiBoZWlnaHQ9IjE0NCIgdmlld0JveD0iMCAwIDE3NiAxNDQiIGZpbGw9IiNCRTgxQ0IiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBvcGFjaXR5PSIwLjMiIGQ9Ik0xNDYuMjk4IDIxLjM4OTJDMTgzLjUwMiAzOS44OTMgMTQzLjg5NyA3Ny43MTA1IDgwLjMzMDUgMTI2LjI5MkMzMC40Njg1IDE2Ny4zOSAtMi40NDYzNCA3OC41ODg4IDEyLjUwOTYgNDguMDgyNkMyNy40NjU2IDE3LjU3NjQgMTA5LjA5NCAyLjg4NTQ2IDE0Ni4yOTggMjEuMzg5MloiIC8+Cjwvc3ZnPgo=";
export { SvgTextBlob as ReactComponent };